const stringifyValue = value => `"${value}"`

export const manipulateResource = manipulation =>
  async function({ props, graphql, state }) {
    const { type, value, id } = props
    const { selectedFiles, tags: { showShared } } = state.get('media')
    const ids = showShared
      ? selectedFiles.map(stringifyValue)
      : [stringifyValue(id)]

    await graphql.mutate(`{
    ${manipulation}(word: "${value}", type: "${type}", ids: [${ids.join()}])
  }`)
  }

export const addResource = manipulateResource('addResource')

export const deleteResource = manipulateResource('deleteResource')



// WEBPACK FOOTER //
// ./src/modules/Media/actions/manipulateResource.js